/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {ReactNode, useEffect, useRef, useState} from 'react';
import {GetServerSidePropsContext} from 'next';
import {getPageData} from '../../[[...slug]]/index.page';
import {useDispatch, useSelector} from 'react-redux';
import Container from '@wearesection/bandai-react-components/atoms/Container';
import {
  convertToSlug,
  handleConvertToLocaleContentful,
  handleRenderPrice,
  handleReturnSubtitleLanguage,
  isDateLagerThanOneMonthFromNow
} from '~/utils';
import {PLACEHOLDER_IMG} from '~/constants';
import {
  addProductData,
  setDataFilter,
  setEndCursor,
  setEndFeatured,
  setFilterItem,
  setProductData,
  setSortBy,
  setSortItem,
  setTabSelect,
} from '~/redux-toolkit/productListSlice';
import productsApi from '~/pages/api/services/products-api';
import {usePageSetting} from '~/providers/page-context.provider';
import {getGloablByType} from '~/utils/global-operations';
import {checkPrices} from '~/utils/sentry-helper';
import {GLOBAL_TYPE} from '~/constants/content-map-type';
import {useRouter} from 'next/router';
import getParamFilterBy, {handleFormatParamFilter} from '../../games/get-param-filter-by';
import * as Types from '../../../graphql/types';
import {cloneDeep} from 'lodash';
import getListBrand from '../../games/get-list-brand';
import ProduceListOrganisms from '~/components/wrapper/organisms/store-product-list/store-product-list';
import RenderNextLink from '~/components/wrapper/atoms/render-next-link/render-next-link';
import cookie from 'js-cookie';
import {Box} from '@mui/material';
import {BlockRenderer} from '~/components/renderer/block-renderer';


export const handleFormatTablist = (
  isFeatured?: boolean,
  isPreOrder?: boolean,
  isSoldOut?: boolean,
  highest_discount?: number,
  isNew?:boolean,
  dataTranslation?: any,
) => {
  const listTabs: any = {
    isFeatured: {title: dataTranslation?.['estore-products-tab-featured'], color: '#00B0B8'},
    isPreOrder: {title: dataTranslation?.['estore-products-tab-pre-order'], color: '#0169B2 '},
    isSoldOut: {title: dataTranslation?.['estore-products-tab-sold-out'], color: '#737373  '},
    isNew: {title: dataTranslation?.['estore-products-tab-new'], color: '#F5B700'},
    discount: {
      title: `${dataTranslation?.['news-tag-sale']}`,
      color: '#DF4662',
    },
    // discount: {
    //   title: `${dataTranslation['estore-product-sale-up-to' || '']} ${Math.floor(
    //     highest_discount || 0
    //   )}% ${dataTranslation?.['estore-products-tab-off']}`,
    //   color: '#DF4662',
    // },
  };
  const result: any = [];
  if (isFeatured) {
    result.push(listTabs.isFeatured);
  }
  if (isPreOrder) {
    result.push(listTabs.isPreOrder);
  }
  if (highest_discount) {
    result.push(listTabs.discount);
  }
  if (isSoldOut) {
    result.push(listTabs.isSoldOut);
  }
  if (isNew) {
    result.push(listTabs.isNew);
  }
  return result.splice(0, 2);
};

export const handleFormatPlatforms = (listPlatform: any[]): string[] => {
  if (!listPlatform.length) return listPlatform;

  const newListPlatform: any[] = [];
  const arrayPlatform = listPlatform.map(item => {
    const newItem = item.title?.trim()?.toLowerCase();
    if (
      newItem === 'nintendo 3ds' ||
      newItem === 'nintendo switch' ||
      newItem === 'nintendo 3ds xl'
    ) {
      return 'Nintendo';
    }
    if (
      newItem === 'playstation 4' ||
      newItem === 'playstation 5' ||
      newItem === 'ps4' ||
      newItem === 'ps5'
    ) {
      return 'PlayStation';
    }
    if (
      newItem === 'xbox 360' ||
      newItem === 'xbox one' ||
      newItem === 'xbox series x' ||
      newItem === 'xbox series x|s' ||
      newItem === 'xbox series s/x' ||
      newItem === 'xbox series s'
    ) {
      return 'XBOX';
    }
    if (newItem === 'steam' || newItem === 'pc') {
      return 'Steam';
    }
    return newItem;
  });
  arrayPlatform.map(item => {
    if (!newListPlatform.includes(item)) {
      newListPlatform.push(item);
    }
  });
  const data: any = [];
  arrayPlatform.map(item => {
    if (item === 'PlayStation') {
      data[0] = item;
    } else if (item === 'Nintendo') {
      data[1] = item;
    } else if (item === 'XBOX') {
      data[2] = item;
    } else if (item === 'Steam') {
      data[3] = item;
    } else {
      data.push(item);
    }
  });
  return data;
};

export const handleFormatProducts = (product: any[], dataTranslation?: any, locale?: any) => {
  if (!product?.length) {
    return [];
  }

  return product.map((item: any) => {
    return {
      id: item?.id,
      tabList: handleFormatTablist(
        item?.isFeatured,
        item?.isPreOrder,
        item?.isSoldOut,
        item?.highest_discount,
        isDateLagerThanOneMonthFromNow(parseInt(item?.releaseDate) * 1000),
        dataTranslation || {}
      ),
      isMerchandise: item?.isMerchandise ?? false,
      listIcon: item?.isMerchandise ? [] : handleFormatPlatforms(item?.platforms || []),
      href: item?.isMerchandise
        ? `/store/merchandise/${convertToSlug(item?.title || '')}`
        : `/store/games/${convertToSlug(item?.title || '')}`,
      nextLink: (href: string, child: ReactNode) => (
        <RenderNextLink href={`${href}`} child={child} />
      ),
      hrefImg: item?.mainImage || PLACEHOLDER_IMG,
      titleGame: item?.title,
      language:
        item?.isMerchandise || !item?.language
          ? ''
          : handleReturnSubtitleLanguage(`${item?.language}`.split(','), locale),
      isDLC: item?.isDLC || false,
      titleDLC: 'DLC',
      titleFrom: dataTranslation?.['label-from'] || '',
      price: `${handleRenderPrice(item?.sale_price || '00', null, locale)}`,
      priceOld:
        !item?.highest_discount || item?.sale_price === item?.default_price
          ? ''
          : `${handleRenderPrice(item?.default_price || '00', null, locale)}`,
      titleSale: item?.highest_discount
        ? `${item?.highest_discount}% ${dataTranslation['estore-products-tab-off']} `
        : '',
    };
  });
};

export const handleFormatItemFilter = (filter: any) => {
  const newFilter = cloneDeep(filter);
  if (newFilter?.price) {
    const listPrice: any[] = filter?.price ?? [];

    const lengthPrice = listPrice.length;
    delete newFilter.price;
    if (lengthPrice === 1 && listPrice?.[0] === 'on_sale') {
      newFilter.price = {on_sale: true};
    }
    if (lengthPrice === 1 && listPrice?.[0] === '>250') {
      newFilter.price = {minPrice: 250};
    }
    if (lengthPrice === 1 && listPrice?.[0] === 50) {
      newFilter.price = {maxPrice: 50};
    }
    if (lengthPrice === 1 && listPrice?.[0]?.length === 2) {
      const price = listPrice?.[0] || [];
      newFilter.price = {maxPrice: price?.[1], minPrice: price?.[0]};
    }
  }
  if (!newFilter?.platform?.length) {
    delete newFilter.platform;
  }
  if (!newFilter?.genre?.length) {
    delete newFilter.genre;
  }

  return newFilter;
};
interface IProductListing {
  data: any;
  dataBrand: any;
  tabList: any[];
  seo: any;
  filterPrice: any;
  sortBy: any;
  filterData: any;
}

const EStoreGameListing = (props: IProductListing) => {
  const {locale = '', query} = useRouter();
  const {globalData} = usePageSetting();
  const dataTranslation = globalData?.dataTranslation?.[0] ?? {};
  const {dataBrand, tabList, seo, filterPrice, sortBy, filterData} = props;
  const dispatch = useDispatch();
  const tabSelect: number = useSelector(
    (state: any) => state?.productList?.tabSelect || tabList?.[0]?.value
  );
  const sortItem: number = useSelector((state: any) => state?.productList?.sortItem || 'NEWEST');
  const filterItem: any = useSelector((state: any) => state?.productList?.filterItem || {});
  const productList: any = useSelector((state: any) => state?.productList?.productData || []);
  const endCursor: any = useSelector((state: any) => state?.productList?.endCursor || '');
  const endFeatured: any = useSelector((state: any) => state?.productList?.endFeatured || false);

  const refFirstDispatch = useRef<boolean>(true);
  const refTimeOut = useRef<any>();
  const refTimeOutFirstLoad = useRef<any>();

  // Query platform
  const platformQuery = query.p ?? '';
  const genreQuery = query.gr ?? '';
  const priceQuery = query.pr ?? '';

  const PRICE_LIST: any = {
    'Under S$50': 50,
    'On sale': 'on_sale',
  };

  // save product list
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);

  // Query first load
  const [firstLoad, setFirstLoad] = useState<boolean>(true);
  const [isEmptyData, setIsEmptyData] = useState<boolean>(false);
  const refCallApi = useRef<any>(true);
  const refPriceMax = useRef<number>(1000);

  const TypeTabFilter: any = {
    title: dataTranslation['estore-products-title-games'] || '',
    labelPill: dataTranslation['estore-products-tab-sort-filter'] || '',
    tabList: tabList,
    titleSelect: 'all',
  };

  // cleanup
  useEffect(() => {
    return () => {
      refCallApi.current = false;
      window.clearTimeout(refTimeOut.current);
    };
  }, []);

  // get data filter content
  useEffect(() => {
    const items = filterData?.items;
    const lengthBrands = !!dataBrand?.gameBrandCollection?.items?.length;
    let result: {title: string; name: string; isChecked: boolean}[] = [];
    if (lengthBrands) {
      result = dataBrand?.gameBrandCollection?.items.map((item: any) => {
        return {
          title: item.title,
          name: item?.idForBig,
          isChecked: false,
        };
      });
    }
    if (items?.length) {
      const newFilter = handleFormatParamFilter(
        filterData as Types.FilterByCollection,
        dataTranslation || {},
        true
      );
      const currencyCode = JSON.parse(cookie.get('currentValue') || '{"symbol":"S$"}');
      const newPrices = {
        countSelect: 0,
        dataFilter: filterPrice,
        showMore: false,
        title:
          dataTranslation['estore-products-title-filter-price'] +
          `${
            ['tc', 'ko-kr'].includes(`${locale}`.toLowerCase()) ? '' : ` (${currencyCode?.symbol})`
          }`,
        value: 'price',
        type: 'radio',
      };

      const newBrands = {
        countSelect: 0,
        dataFilter: result,
        showMore: false,
        title: dataTranslation['estore-filter-brands'],
        value: 'brand',
      };

      const newDataFilter = [...newFilter];
      if (lengthBrands) {
        newDataFilter.push(newBrands);
      }
      if (
        filterPrice?.length &&
        !['ko-kr', 'tc'].includes(`${locale}`.toLowerCase()) &&
        !['RM', 'Rp', '₱', '฿'].includes(currencyCode?.symbol)
      ) {
        refPriceMax.current = (filterPrice[filterPrice?.length - 2 || 0]?.name || 0) as number;
        newDataFilter.push(newPrices);
      }

      if (newDataFilter?.length) {
        dispatch(setDataFilter(newDataFilter));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData, filterPrice, dataTranslation]);

  //set data sort
  useEffect(() => {
    if (sortBy?.length) {
      dispatch(setSortBy(sortBy));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortBy]);

  const handleSetData = (res: any, type?: string) => {
    const {data, meta} = res?.data;
    dispatch(setEndCursor(meta?.endCursor || ''));
    setHasNextPage(meta?.hasNextPage || '');
    if (meta?.endFeatured) {
      dispatch(setEndFeatured(true));
    }
    const newProducts = handleFormatProducts(data, dataTranslation || {}, locale);
    checkPrices(data, "store-games-index");
    if (type === 'add') {
      dispatch(addProductData(newProducts));
    } else {
      dispatch(setProductData(newProducts));
      if (![...newProducts].length) {
        setIsEmptyData(true);
      }
    }
  };

  // get load more product
  const handleLoadMore = () => {
    if (productList?.length && hasNextPage) {
      productsApi
        .getListProducts(
          {
            type: tabSelect,
            sort: sortItem,
            endCursor: endCursor,
            endFeatured: endFeatured,
            filter: handleFormatItemFilter(filterItem),
          },
          handleConvertToLocaleContentful(locale as string)
        )
        .then((res: any) => {
          if (res.status !== 200) {
            throw res;
          }
          handleSetData(res, 'add');
        })
        .catch((e: any) => {
          console.log(e);
        });
    }
  };

  const handleChangeSelectTab = (v: any, callback?: () => void) => {
    dispatch(setTabSelect(v));
    setTimeout(() => {
      dispatch(setProductData([]));
      setHasNextPage(true);
    }, 300);
    setIsEmptyData(false);
    dispatch(setEndFeatured(false));
    callback?.();
    const newFilter = handleFormatItemFilter(filterItem);
    productsApi
      .getListProducts(
        {
          type: v,
          sort: sortItem,
          filter: newFilter,
        },
        handleConvertToLocaleContentful(locale as string)
      )
      .then((res: any) => {
        if (res.status !== 200) {
          throw res;
        }
        if (!refCallApi.current) {
          return;
        }
        handleSetData(res);
        // callback?.();
      })
      .catch((e: any) => {
        console.log(e);
      });
  };

  const handleFilter = (filter: any, sort: any, callback?: () => void) => {
    refFirstDispatch.current = false;
    setFirstLoad(false);
    setIsEmptyData(false);
    setHasNextPage(true);
    dispatch(setSortItem(sort));
    dispatch(setProductData([]));
    dispatch(setEndFeatured(false));
    callback?.();
    const newFilter = handleFormatItemFilter(filter);
    dispatch(setFilterItem(filter));

    productsApi
      .getListProducts(
        {
          type: tabSelect,
          sort: sort || 'NEWEST',
          filter: newFilter,
        },
        handleConvertToLocaleContentful(locale as string)
      )
      .then((res: any) => {
        if (res.status !== 200) {
          throw res;
        }
        if (!refCallApi.current) {
          return;
        }
        handleSetData(res);
      })
      .catch((e: any) => {
        console.log(e);
      });
  };
  //get init productList
  useEffect(() => {
    if (!Object.keys(dataTranslation)?.length || !!productList?.length || !window) {
      return;
    }

    if (firstLoad && refFirstDispatch.current) {
      const newFilterItem = {
        platform: [...(filterItem?.platform || [])],
        genre: [...(filterItem?.genre || [])],
        price: filterItem?.price || [],
      };
      if (
        (!newFilterItem?.platform?.length || !newFilterItem?.platform?.includes(platformQuery)) &&
        !!platformQuery
      ) {
        newFilterItem.platform = [...(newFilterItem?.platform || []), platformQuery];
      }
      if (
        (!newFilterItem?.genre?.length || !newFilterItem?.genre?.includes(genreQuery)) &&
        genreQuery
      ) {
        newFilterItem.genre = [...(newFilterItem?.genre || []), genreQuery];
      }
      if (
        (!newFilterItem?.price || !newFilterItem?.price?.includes(PRICE_LIST[priceQuery as any])) &&
        !!priceQuery
      ) {
        newFilterItem.price = [...(newFilterItem.price || []), PRICE_LIST[priceQuery as any]];
      }

      if (refTimeOutFirstLoad.current) {
        window.clearTimeout(refTimeOutFirstLoad.current);
      }

      refTimeOutFirstLoad.current = setTimeout(() => {
        refTimeOutFirstLoad.current = undefined;
        productsApi
          .getListProducts(
            {
              type: tabSelect,
              sort: sortItem,
              filter: handleFormatItemFilter(newFilterItem),
            },
            handleConvertToLocaleContentful(locale as string)
          )
          .then((res: any) => {
            if (res.status !== 200) {
              throw res;
            }
            handleSetData(res);
            setFirstLoad(false);
          })
          .catch((e: any) => {
            setFirstLoad(false);
            console.log(e);
          })
          .finally(() => {
            if (refFirstDispatch.current) {
              dispatch(setFilterItem(newFilterItem));
            }
            refFirstDispatch.current = false;
          });
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterItem, genreQuery, platformQuery, priceQuery, firstLoad, dataTranslation, productList]);

  const SeoStandard = seo?.games
    ? {
        __typename: 'SeoStandard',
        ...seo.games,
      }
    : null;

  return (
    <Box>
      {SeoStandard && <BlockRenderer block={[SeoStandard]} />}
      <Container
        sx={{
          paddingTop: {
            xs: '72px',
            md: '80px',
          },
          paddingBottom: '40px',
        }}
      >
        <ProduceListOrganisms
          hasNextPage={hasNextPage}
          onLoadMore={handleLoadMore}
          onlSelectTab={handleChangeSelectTab}
          onFilter={handleFilter}
          typeTabFilter={TypeTabFilter}
          isEmptyData={isEmptyData}
          productList={productList}
        />
      </Container>
    </Box>
  );
};

export const getStaticProps = async (ctx: GetServerSidePropsContext) => {
  const preview = !!(process && process.env && process.env.NEXT_PUBLIC_PREVIEW);

  const promises: [
    ReturnType<typeof getPageData>,
    ReturnType<typeof getListBrand>,
    ReturnType<typeof getGloablByType>,
    ReturnType<typeof getGloablByType>,
    ReturnType<typeof getGloablByType>,
    ReturnType<typeof getGloablByType>,
    ReturnType<typeof getParamFilterBy>
  ] = [
    getPageData({slug: 'store', preview}, ctx),
    getListBrand(0, 20, handleConvertToLocaleContentful(ctx.locale as string), 'idForBig'),
    getGloablByType(handleConvertToLocaleContentful(ctx.locale as string), GLOBAL_TYPE.StoreTab),
    getGloablByType(handleConvertToLocaleContentful(ctx.locale as string), GLOBAL_TYPE.SEO),
    getGloablByType(
      handleConvertToLocaleContentful(ctx.locale as string),
      GLOBAL_TYPE.FilterPriceProducts
    ),
    getGloablByType(
      handleConvertToLocaleContentful(ctx.locale as string),
      GLOBAL_TYPE.SortByProducts
    ),
    getParamFilterBy(handleConvertToLocaleContentful((ctx.locale as string) ?? '')),
  ];
  const [pageData, dataBrand, tabList, seo, filterPrice, sortBy, filterData] = await Promise.all(
    promises
  );
  const {data} = pageData;
  return {
    props: {
      data,
      seo,
      filterPrice,
      dataBrand,
      sortBy,
      filterData,
      tabList: tabList?.games_listing || [],
    },
    revalidate: 60,
  };
};

export default EStoreGameListing;
